import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/exame-imagem`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create: (id, queryParms = {}) => {

            return repository.get(`${baseUrl}/${id}/create?${urlUtil.serialize(queryParms)}`)
        },
        store: params => {

            return repository.post(`${baseUrl}`, params)
        },
    }
}